import * as React from 'react';
import { UIHeading1, Body1 } from '@cian/ui-kit/typography';

import { ParticipationMobile } from '../../ParticipationMobile';
import { ApprovalContainerNew } from '../../../containers/ApprovalContainer/ApprovalContainerNew';
import { IAgentCardParticipation } from '../../../types/agentCard';

import * as styles from './index.css';

interface IGeneralInfoMobileProps {
  name?: string;
  companyName?: string;
  age?: string;
  participations: IAgentCardParticipation[];
}

export const GeneralInfoMobile: React.FunctionComponent<IGeneralInfoMobileProps> = ({
  name,
  companyName,
  age,
  participations,
}) => {
  return (
    <>
      <UIHeading1>{name}</UIHeading1>
      {!!companyName && !!age && (
        <div className={styles['description']} data-name="GeneralInfoMobileDescription">
          <Body1>
            {!!companyName && companyName}
            {!!companyName && !!age && <br />}
            {!!age && `${age} на Циане`}
          </Body1>
        </div>
      )}
      <div className={styles['credentials']}>
        {participations.map(item => (
          <ParticipationMobile key={item.type} participation={item} />
        ))}
        <ApprovalContainerNew />
      </div>
    </>
  );
};
